import classNames from 'classnames';
import React from 'react';
import FakeSelectionButton from './FakeSelectionButton';
import * as styles from './TableControl.module.scss';
import addTestId from '../../../utils/addTestId';

interface TableControlProps {
  selected: boolean;
  onSelect: () => void;
}

const TableControl = ({ selected, onSelect }: TableControlProps) => (
  <div className={classNames({ [styles.selected]: selected })}>
    <FakeSelectionButton
      {...addTestId('tableControl')}
      data-no-print
      className={styles.selectButton}
      onClick={onSelect}
    />
  </div>
);

export default TableControl;
